import { render } from "./ActionSheetItem.vue?vue&type=template&id=6be1d4a0"
import script from "./ActionSheetItem.vue?vue&type=script&lang=js"
export * from "./ActionSheetItem.vue?vue&type=script&lang=js"
script.render = render

export default script